import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip,
  Stack,
  Box,
} from '@mui/material';

const CourseCard = ({ course }) => {
  const formattedDate = course.created_at ? new Date(course.created_at).toLocaleDateString() : null;

  return (
    <Card
      sx={{
        maxWidth: { xs: '100%', md: 320 },
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        // increased glow behind if sponsored
        boxShadow: course.sponsored ? '0 0 24px 6px rgba(255, 105, 180, 0.7)' : 'none',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'scale(1.03)',
          boxShadow: course.sponsored ? '0 0 36px 12px rgba(255, 105, 180, 0.85)' : '0 4px 8px rgba(0, 0, 0, 0.15)',
        },
            }}
          >
          
        {course.sponsored && (
          <Box
            sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          bgcolor: 'secondary.main',
          color: 'black',
          padding: '2px 8px',
          borderRadius: '4px',
          fontWeight: 'bold',
          fontSize: '0.75rem',
          animation: 'flash 0.5s infinite',
          '@keyframes flash': {
            '0%, 100%': { opacity: 1 },
            '50%': { opacity: 0.5 },
          },
            }}
          >
            Sponsored
          </Box>
        )}
        <CardMedia
          component="img"
          height="160"
          image={course.image}
          alt={course.name}
        />
        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" fontWeight="600" gutterBottom noWrap>
            {course.name}
          </Typography>
          <Stack direction="row" gap={1} mb={1} flexWrap="wrap">
            <Chip label={course.category} size="small" color={course.sponsored ? "secondary" : "primary"} />
            <Chip label={course.subcategory} size="small" variant="outlined" />
          </Stack>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, flexGrow: 1, overflow: 'hidden' }}
          >
            {course?.description?.replace(/(<([^>]+)>)/gi, '').slice(0, 120)}...
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" mb={1}>
            {course.created_at ? <>Created: {formattedDate}</> : 'Limited Time Discount'}
          </Typography>
          {/* price(striked off),sale_price */}
        <Typography variant="body1" fontWeight="bold" color="text.primary" mb={1}>
          {course.sale_price !== null && course.sale_price !== undefined ? (
            <>
              <span style={{ textDecoration: 'line-through', color: 'grey' }}>
                ${course.price}
              </span>{' '}
              ${course.sale_price}
            </>
          ) : (
            `$${course.price}`
          )}
        </Typography>

        <Box mt="auto">
          <Button
            href={course.sponsored ? course.url : `/courses/${course.slug}`}
            component="a"
            variant="contained"
            fullWidth
            color={course.sponsored ? 'secondary' : 'primary'}
            sx={{
              fontWeight: course.sponsored ? 'bold' : 'normal',
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
             {!course.sponsored ? "View Course" : "Unlock Discount"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CourseCard;
